import { phoneMask } from '@/helpers/phoneMask'
import React, { useState } from 'react'
import { FieldErrors, FieldValues, UseFormRegister } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

interface TFieldValue {
    phone: string,
}

interface Props {
    register: UseFormRegister<FieldValues>,
    errors: FieldErrors<TFieldValue>,
    value: string,
    setValue: (val: string) => void,
    defaultValue?: any
}

const ForPartnersPhone: React.FC<Props> = ({ register, errors, value, setValue, defaultValue }) => {
    const [isFocused, setIsFocused] = useState<boolean>(false)
    const { t } = useTranslation()

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = event.target.value;
        const maskedInput = phoneMask(inputValue);
        setValue(maskedInput);
    };

    const handleBlur = () => {
        setIsFocused(false)
    }

    return (
        <div className={`for-partners__input-block ${isFocused && 'for-partners__input-block_focused'}`}>
            <label
                style={errors.phone ? { color: '#D17CF9' } : {}}
                htmlFor='phone'>
                {errors.phone ? errors.phone.message : t('footerFormphoneUp')}
            </label>
            <input
                style={errors.phone ? { color: '#D17CF9' } : {}}
                value={value}
                autoComplete='off'
                onBlurCapture={handleBlur}
                onFocus={() => setIsFocused(true)}
                name='phone'
                onChangeCapture={handleInputChange}
                type='text'
                placeholder='+7 900 000 00 00'
                defaultValue={defaultValue ? defaultValue : ""}
                {...register('phone', {
                    required: false, minLength: {
                        value: 16,
                        message: t('footerFormPhonePatternError')
                    }
                })}
            />
        </div>
    )
}

export default ForPartnersPhone
